import { createRouter, createWebHistory } from 'vue-router'
import MapApp from '../components/MapApp.vue'
import LandingPage from '../views/LandingPage.vue'
import QuizView from '../views/QuizView.vue'
import LeaderboardsView from '../views/LeaderboardsView.vue'
import ProfilePage from '../views/ProfilePage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MapApp
  },
  {
    path: '/landing',
    name: 'Landing',
    component: LandingPage
  },
  {
    path: '/app',
    name: 'MapApp',
    component: MapApp
  },
  {
    path: '/location/:slug',
    name: 'Location',
    component: MapApp,
    props: true
  },
  {
    path: '/article/:slug',
    name: 'Article',
    component: MapApp,
    props: true
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('../views/BlogPage.vue')
  },
  {
    path: '/blog/:id',
    name: 'BlogPost',
    component: () => import('../views/BlogPost.vue'),
    props: true
  },
  {
    path: '/quiz/:id',
    name: 'Quiz',
    component: QuizView,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/leaderboards',
    name: 'Leaderboards',
    component: LeaderboardsView
  },
  {
    path: '/profile/:username',
    name: 'Profile',
    component: ProfilePage,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = localStorage.getItem('auth-token')

  if (requiresAuth && !isAuthenticated) {
    // Redirect to home with auth modal
    next({
      path: '/',
      query: { showAuth: true, redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router